export const COMMON_ANALYTICS_ATTRIBUTES = {
	actionSubjectId: 'globalJiraSettingsNavigationMenuItem',
	componentType: 'fixedItem',
	level: 1,
	settingsGroup: 'products',
};
